<template>
	<a-modal width="55%" :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
		:confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose">
		<a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
			<!--可编辑区域 start-->
			<div class="hidden">
				<a-form-item label="id" name="id">
					<a-input v-model:value="form.id" />
				</a-form-item>
			</div>
			<a-row :gutter="[24, 8]">
				<a-col :span="24">
					<div style="margin-bottom: 10px;font-size: 20px;color: rgba(0, 0, 0, 0.85)">成果信息</div>
				</a-col>
				<a-col :span="12">
					<a-form-item label="成果名称" name="name">
						<a-input v-model:value="form.name" placeholder="请输入" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="所属高新技术领域" name="technoSphere">
						<DictSelect v-model:value="form.technoSphere" :dict-name="'belong_techField'" placeholder="请选择" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="合作方式" name="cooperationWay">
						<DictSelect v-model:value="form.cooperationWay" :dict-name="'cooperation_methods'" placeholder="请选择" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="交易价格(万元)" name="transactionValue">
						<a-inputNumber style="width: 100%;" v-model:value="form.transactionValue" placeholder="请输入" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="应用行业" name="applicationIndustry">
						<DictSelect v-model:value="form.applicationIndustry" :dict-name="'research_field'" placeholder="请选择" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="产业类型" name="industryType">
						<DictSelect v-model:value="form.industryType" :dict-name="'industry_type'" placeholder="请选择" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="关键字(多个逗号隔开)" name="keyWord">
						<a-input v-model:value="form.keyWord" placeholder="请输入" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="技术成熟度" name="techMaturity">
						<DictSelect v-model:value="form.techMaturity" :dict-name="'technical_maturity'" placeholder="请选择" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="专利状况已授权(授权数)" name="authorizedCount">
						<a-inputNumber style="width: 100%;" v-model:value="form.authorizedCount" placeholder="请输入" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="已投入经费（万元）" name="expensesIncurred">
						<a-inputNumber style="width: 100%;" v-model:value="form.expensesIncurred" placeholder="请输入" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="预期再投入经费（万元）" name="expectedReinvestment">
						<a-inputNumber style="width: 100%;" v-model:value="form.expectedReinvestment" placeholder="请输入" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="成果类型" name="achievementClassify">
						<DictSelect v-model:value="form.achievementClassify" :dict-name="'result_type'" placeholder="请选择" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="成果立项时间" name="started">
						<date-picker style="width: 100%" v-model:value="form.started" :format="dateFormat.DATE_DAY" :showTime="false" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="成果发布时间" name="ended">
						<date-picker style="width: 100%" v-model:value="form.ended" :format="dateFormat.DATE_DAY" :showTime="false" />
					</a-form-item>
				</a-col>
				<a-col :span="24">
					<a-form-item label="成果图片" name="achievementPicture">
						<img-upload v-model:value="form.achievementPicture" />
					</a-form-item>
				</a-col>
				<a-col :span="24">
					<a-form-item label="成果摘要" name="achievementAbstract">
						<a-textarea v-model:value="form.achievementAbstract" placeholder="请输入" :rows="4" showCount />
					</a-form-item>
				</a-col>
				<a-col :span="24">
					<a-form-item label="成果简介" name="achievementSynopsis">
						<a-textarea v-model:value="form.achievementSynopsis" placeholder="请输入" :rows="4" showCount />
					</a-form-item>
				</a-col>
				<a-col :span="24">
					<div style="margin-bottom: 10px;font-size: 20px;color: rgba(0, 0, 0, 0.85)">负责人信息</div>
				</a-col>
				<a-col :span="24">
					<a-form-item label="负责人头像" name="headPortrait">
						<img-upload v-model:value="form.headPortrait" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="负责人姓名" name="principal">
						<a-input v-model:value="form.principal" placeholder="请输入" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="负责人性别" name="sex">
						<a-select v-model:value="form.sex" :options="sexData" placeholder="请选择" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="负责人手机号" name="principalPhone">
						<a-input v-model:value="form.principalPhone" placeholder="请输入" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="出生日期" name="birthDate">
						<date-picker style="width: 100%" v-model:value="form.birthDate" :format="dateFormat.DATE_DAY" :showTime="false" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="学历" name="education">
						<DictSelect v-model:value="form.education" :dict-name="'education_background'" placeholder="请选择" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="专业" name="major">
						<DictSelect v-model:value="form.major" :dict-name="'education_major'" placeholder="请选择" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="职务" name="duty">
						<a-input v-model:value="form.duty" placeholder="请输入" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="职称" name="rank">
						<a-input v-model:value="form.rank" placeholder="请输入" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="研究领域" name="researchField">
						<DictSelect v-model:value="form.researchField" :dict-name="'research_field'" placeholder="请选择" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="学科" name="subject">
						<DictSelect v-model:value="form.subject" :dict-name="'achievements_subject'" placeholder="请选择" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="团队信息" name="teamInformation">
						<a-input v-model:value="form.teamInformation" placeholder="请输入" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="论文" name="paper">
						<a-input v-model:value="form.paper" placeholder="请输入" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="邮箱" name="email">
						<a-input v-model:value="form.email" placeholder="请输入" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="所属团体名称" name="belongTeam">
						<a-input v-model:value="form.belongTeam" placeholder="请输入" />
					</a-form-item>
				</a-col>
				<a-col :span="24">
					<a-form-item label="个人简介" name="individualResume">
						<a-textarea v-model:value="form.individualResume" placeholder="请输入" :rows="4" showCount />
					</a-form-item>
				</a-col>
				<a-col :span="24">
					<a-form-item label="参与项目" name="participationProject">
						<a-textarea v-model:value="form.participationProject" placeholder="请输入" :rows="4" showCount />
					</a-form-item>
				</a-col>
				<a-col :span="24">
					<a-form-item label="参与荣誉" name="achievementHonor">
						<a-textarea v-model:value="form.achievementHonor" placeholder="请输入" :rows="4" showCount />
					</a-form-item>
				</a-col>
				<!--可编辑区域 end-->
			</a-row>
		</a-form>
	</a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import { formMixin } from "@/mixins";
import { achievementInfo } from "@/api/achievementsService";
import DictSelect from "@/components/other/DictSelect";
import { dateFormat } from "@/config/variableConfig";

export default {
	name: "UserModal",
	components: { DictSelect },

	mixins: [formMixin],
	data() {
		return {
			dateFormat,
			sexData: [{ label: '男', value: '0' }, { label: '女', value: '1' }],
			form: {
				id: null,
			},
			rules: {
				principalPhone: [dataCheck.required({}), dataCheck.mobile_phone,],
				principal: [dataCheck.required({})],
				birthDate: [dataCheck.required({})],
				sex: [dataCheck.required({})],
				education: [dataCheck.required({})],
				major: [dataCheck.required({})],
				achievementPicture: [],
				rank: [],
				duty: [],
				researchField: [],
				subject: [],
				achievementSynopsis: [],
				paper: [],
				email: [],
				belongTeam: [],
				achievementAbstract: [dataCheck.required({})],
				started: [dataCheck.required({})],
				ended: [dataCheck.required({})],
				individualResume: [],
				achievementHonor: [],
				participationProject: [],
				headPortrait: [],
				name: [dataCheck.required({})],
				technoSphere: [dataCheck.required({})],
				cooperationWay: [dataCheck.required({})],
				transactionValue: [dataCheck.required({ type: 'number' })],
				applicationIndustry: [dataCheck.required({})],
				industryType: [dataCheck.required({})],
				keyWord: [],
				techMaturity: [],
				authorizedCount: [],
				expensesIncurred: [],
				expectedReinvestment: [],
				teamInformation: [],
				achievementClassify: [dataCheck.required({})],
				id: [],
			},
			submitUrl: achievementInfo.saveOrUpdate
		}
	},
}
</script>
<style scoped lang="less"></style>
